import { lazy } from 'solid-js'
import { messages } from '../../pages/listing-settings-page/listing-settings-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/listing-settings-page/listing-settings-page.jsx')),
    path: '/property/:property_id/settings',
    requiredMode: 'host',
    showFooter: false,
    showHeaderMenu: false,
    showHostView: true,
    showSidebar: true,
    titleMessage: messages.title,
}
